export default __webpack_public_path__ + "static/media/diagram.377dbb19.svg";